import { getProjectBySlug } from '../../../../data/projects';
import { CaseStudyPage } from '../../../../components/caseStudy';

const project = getProjectBySlug('shelter');

const ShelterPage = () => <CaseStudyPage project={project} />;

export default ShelterPage;
